
import React      from 'react';
import moment     from 'moment';
import CSSModules from 'react-css-modules';

import PageLink from '../PageLink';
import classNames   from 'classnames/bind';
import stylingUtils from '../../services/stylingUtilities';

import style from './style.scss';

class Footer extends React.Component {

    _getClassName(mainClass) {

        var cx = classNames.bind(style);

        if (mainClass === 'footer') {
            var baseStyle = {
                'panel': true,
            }
        }

        if (mainClass === 'footer__content') {
            var baseStyle = {
                'panel__content': true
            }
        }

        if (mainClass === 'footer__col-1' || mainClass === 'footer__col-2') {
            var baseStyle = {
                'footer__col': true,
                'clearfix': true
            }
        }

        if (mainClass === 'footer__panel--copyright') {
            var baseStyle = {
                'footer__panel': true,
                'clearfix': true
            }
        }

        return cx(stylingUtils.mergeClassNames(baseStyle, mainClass));
    }

    render() {

        return (
            <footer className={this._getClassName('footer')}>

                <div className={this._getClassName('footer__content')}>

                    <div className={this._getClassName('footer__col-1')}>
                        <div className={style['footer__panel']}>
                            <h2 className={style['footer__list-heading']}>Services</h2>

                            <ul className={style['footer__list']}>
                                <li className={style['footer__list-item']}>
                                    <a className={style['footer__item-link']}
                                       href="http://www.rheglobal.com/consulting">
                                        Consulting
                                    </a>
                                </li>
                                <li className={style['footer__list-item']}>
                                    <a className={style['footer__item-link']}
                                       href="http://rhenvironmental.co.uk/forums">
                                        Forums
                                    </a>
                                </li>
                                <li className={style['footer__list-item']}>
                                    <PageLink to={ '/' } isIndex={ true } className={style['footer__item-link']}>
                                        Training
                                    </PageLink>
                                </li>
                            </ul>
                        </div>

                        <div className={style['footer__panel']}>
                            <h2 className={style['footer__list-heading']}>Products</h2>

                            <ul className={style['footer__list']}>
                                <li className={style['footer__list-item']}>
                                    <a className={style['footer__item-link']}
                                       href="http://www.thenoiseapp.com">
                                        The Noise App
                                    </a>
                                </li>
                                <li className={style['footer__list-item']}>
                                    <a className={style['footer__item-link']}
                                       href="http://www.riams.org">
                                        RIAMS
                                    </a>
                                </li>
                                <li className={style['footer__list-item']}>
                                    <a className={style['footer__item-link']}
                                       href="http://www.whitedocs.com">
                                        Whitedocs
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div className={style['footer__panel']}>
                            <h2 className={style['footer__list-heading']}>Legal</h2>

                            <ul className={style['footer__list']}>
                                <li className={style['footer__list-item']}>
                                    <a className={style['footer__item-link']}
                                       href="http://rheglobal.com/copyright">
                                        Copyright
                                    </a>
                                </li>
                                <li className={style['footer__list-item']}>
                                    <a className={style['footer__item-link']}
                                       href={`${window.config['tos_licence_link']}`}>
                                        Terms of Service
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div className={style['footer__panel']}>
                            <h2 className={style['footer__list-heading']}>Connect</h2>

                            <ul className={style['footer__list']}>
                                <li className={style['footer__list-item']}>
                                    <a className={style['footer__item-link']}
                                       href="https://twitter.com/RHEtraining">
                                        Twitter
                                    </a>
                                </li>
                                <li className={style['footer__list-item']}>
                                    <a className={style['footer__item-link']}
                                       href="https://www.linkedin.com/company/2307240">
                                        LinkedIn
                                    </a>
                                </li>
                                <li className={style['footer__list-item']}>
                                    <a className={style['footer__item-link']}
                                       href="https://www.facebook.com/RHEglobal/">
                                        Facebook
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div className={style['footer__panel']}>
                            <h2 className={style['footer__list-heading']}>Help</h2>

                            <ul className={style['footer__list']}>
                                <li className={style['footer__list-item']}>
                                    <a className={style['footer__item-link']}
                                       href="http://www.rheglobal.com/contact">
                                        Contact
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div className={style['footer__panel']}>

                            <div className={style['footer__copyright-content-wrap']}>
                                <div className={style['footer__copyright-wrapper']}>
                                    <div className={style['footer__list-heading']}>
                                        Copyright
                                    </div>
                                    <p className={style['footer__copyright-text']}>
                                        &copy; RH Environmental Ltd.<br/>
                                        { moment().year() } All Rights Reserved
                                    </p>
                                </div>
                            </div>
                        </div>


                    </div>

                    <div className={this._getClassName('footer__col-2')}>
                        <div className={style['footer__panel']}>
                            <a href="https://www.rheglobal.com">
                                <img className={style['footer__logo']} src="/assets/images/rhe-footer-logo.png" />
                            </a>
                        </div>

                    </div>

                </div>

            </footer>
        );
    }
}

export default CSSModules(Footer, style);


// WEBPACK FOOTER //
// ./components/Footer/index.js